import axios from "axios";
import { Message } from "element-ui";
import { apiPath } from "@/config";
import router from "@/router";

const progressBar = {
  init() {
    if (document.getElementById("custom-progress-bar")) return;
    const bar = document.createElement("div");
    bar.id = "custom-progress-bar";
    bar.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 0;
      height: 3px;
      background: linear-gradient(90deg, #3DCD58, #8cc43f);
      z-index: 99999;
      transition: width 0.3s ease, opacity 0.3s ease;
      box-shadow: 0 1px 3px rgba(61, 205, 88, 0.3);
      pointer-events: none;
    `;
    document.body.appendChild(bar);
  },
  start() {
    this.init();
    const bar = document.getElementById("custom-progress-bar");
    if (bar) {
      bar.style.width = "0%";
      bar.style.opacity = "1";
      bar.offsetHeight;
      bar.style.width = "30%";
    }
  },
  done() {
    const bar = document.getElementById("custom-progress-bar");
    if (bar) {
      bar.style.width = "100%";
      setTimeout(() => {
        bar.style.opacity = "0";
        setTimeout(() => {
          bar.style.width = "0%";
        }, 300);
      }, 300);
    }
  }
};

let loadingNum = 0;
function startLoading() {
  if (loadingNum === 0) progressBar.start();
  loadingNum++;
}
function endLoading() {
  loadingNum--;
  if (loadingNum <= 0) {
    loadingNum = 0;
    progressBar.done();
  }
}

export const TOKEN_KEY = "front_token";
export const USERINFO_KEY = "front_userinfo";

export function getFrontToken() {
  return window.localStorage.getItem(TOKEN_KEY);
}

export function setFrontLogin(loginInfo) {
  const token = loginInfo && loginInfo.token;
  if (token) window.localStorage.setItem(TOKEN_KEY, token);
  if (loginInfo) window.localStorage.setItem(USERINFO_KEY, JSON.stringify(loginInfo));
}

export function clearFrontLogin() {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(USERINFO_KEY);
  window.localStorage.removeItem("oss_token");
  window.localStorage.removeItem("oss_userinfo");
}

export function isFrontLogin() {
  return !!getFrontToken();
}

const request = axios.create({
  baseURL: apiPath,
  timeout: 90 * 1000
});

request.interceptors.request.use(
  (config) => {
    startLoading();
    const token = getFrontToken();
    if (token && !config.skipToken) config.headers["Authori-zation"] = token;
    return config;
  },
  (error) => Promise.reject(error)
);

request.interceptors.response.use(
  (response) => {
    endLoading();
    const res = response.data;
    const path = router.currentRoute.path;
    if (res && (res.code === 401 || res.code === 501)) {
      clearFrontLogin();
      if (response.config.authRequired && !response.config.silentAuth && path !== "/login") {
        Message.error({
          message: res.message || "Unauthorized",
          onClose: () => router.push({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath }
          })
        });
      }
    }
    return res;
  },
  (error) => {
    endLoading();
    if (error.code === "ECONNABORTED" && error.message.indexOf("timeout") !== -1) {
      Message.error("Request timed out. The payment service may be slow, please check your orders later.");
    }
    if (error.response && error.response.status === 401) {
      clearFrontLogin();
      const config = error.response.config || {};
      if (config.authRequired && !config.silentAuth && router.currentRoute.path !== "/login") {
        router.push({
          path: "/login",
          query: { redirect: router.currentRoute.fullPath }
        });
      }
    }
    return Promise.reject(error);
  }
);

const get = (url, params, config) => request({ method: "get", url, params, ...config });
const post = (url, data, config) => request({ method: "post", url, data, ...config });
const postAndGet = (url, data, params, config) => request({ method: "post", url, data, params, ...config });
const postOfGet = (url, params, config) => request({ method: "post", url, params, ...config });
const postOfForm = (url, formData, config) =>
  request({
    method: "post",
    url,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
    ...config
  });

export { request, get, post, postOfGet, postOfForm, postAndGet };
